import React from "react";
import "./country.css";

const Country = (props) => {
  const title = "phone " + props.title;
  return (
    <section>
      <div className={title}></div>
    </section>
  );
};

export default Country;
